import React from 'react';
import {Provider} from 'react-redux';
import {Router} from 'react-router';
import Routes from './Routes';

const Root = ({store, history}) => (
    <Provider store={store}>
        <Router history={history} routes={Routes} />
    </Provider>
);

export default Root;



// WEBPACK FOOTER //
// ./src/Root/Root.js